export default __webpack_public_path__ + "static/media/playstore.774d4921.png";